// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HourglassFilledSvg from "@ant-design/icons-svg/es/asn/HourglassFilled";
import AntdIcon from '../components/AntdIcon';

var HourglassFilled = function HourglassFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HourglassFilledSvg
  }));
};

HourglassFilled.displayName = 'HourglassFilled';
export default React.forwardRef(HourglassFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/HourglassFilled.js
// module id = 1321
// module chunks = 0